/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SILPriceProductInfo } from './SILPriceProductInfo';
import {
    SILPriceProductInfoFromJSON,
    SILPriceProductInfoFromJSONTyped,
    SILPriceProductInfoToJSON,
} from './SILPriceProductInfo';

/**
 * 
 * @export
 * @interface SILPriceInfo
 */
export interface SILPriceInfo {
    /**
     * 
     * @type {Array<SILPriceProductInfo>}
     * @memberof SILPriceInfo
     */
    products?: Array<SILPriceProductInfo>;
}

/**
 * Check if a given object implements the SILPriceInfo interface.
 */
export function instanceOfSILPriceInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SILPriceInfoFromJSON(json: any): SILPriceInfo {
    return SILPriceInfoFromJSONTyped(json, false);
}

export function SILPriceInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SILPriceInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'products': !exists(json, 'products') ? undefined : ((json['products'] as Array<any>).map(SILPriceProductInfoFromJSON)),
    };
}

export function SILPriceInfoToJSON(value?: SILPriceInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'products': value.products === undefined ? undefined : ((value.products as Array<any>).map(SILPriceProductInfoToJSON)),
    };
}

